// extracted by mini-css-extract-plugin
module.exports = {"closeIconContainer":"ThanksModal_closeIconContainer__ijWpt","closeIcon":"ThanksModal_closeIcon__1RmFo","customThanks":"ThanksModal_customThanks__1Cohi"};